import type { BoxProps } from './box.types';

export const defaultBoxProps: Required<Omit<BoxProps, 'backgroundColor'>> = {
	padding: 'spacing-4',
	borderRadius: 'border-radius-s',
	borderWidth: 'border-none',
	borderColor: 'color-background-highlight',
	textAlign: 'left',
};
